/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Table_Buildid1Inputs */

const id_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Build`)
};

const ms_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Binaan`)
};

const da_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build ID`)
};

const de_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-ID`)
};

const en_us2_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build ID`)
};

const es_es2_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de compilación`)
};

const es_mx2_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de compilación`)
};

const fil_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID ng Build`)
};

const fr_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de compilation`)
};

const it_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID build`)
};

const hu_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build azonosító`)
};

const nl_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-ID`)
};

const no_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-ID`)
};

const pl_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID kompilacji`)
};

const pt_br2_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da build`)
};

const pt_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da compilação`)
};

const ro_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID compilare`)
};

const fi_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversion tunnus`)
};

const sv_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygg-ID`)
};

const vi_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Bản dựng`)
};

const tr_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapı ID`)
};

const cs_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID sestavení`)
};

const bg_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID на компилация`)
};

const ru_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID сборки`)
};

const uk_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID збірки`)
};

const ar_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرف البنية`)
};

const hi_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड ID`)
};

const th_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID บิลด์`)
};

const ja_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルドID`)
};

const zh_cn2_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建ID`)
};

const zh_hant1_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置ID`)
};

const ko_builds_table_buildid1 = /** @type {(inputs: Builds_Table_Buildid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드 ID`)
};

/**
* | output |
* | --- |
* | "Build ID" |
*
* @param {Builds_Table_Buildid1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_table_buildid1 = /** @type {((inputs?: Builds_Table_Buildid1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Table_Buildid1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_table_buildid1(inputs)
	if (locale === "ms") return ms_builds_table_buildid1(inputs)
	if (locale === "da") return da_builds_table_buildid1(inputs)
	if (locale === "de") return de_builds_table_buildid1(inputs)
	if (locale === "en-US") return en_us2_builds_table_buildid1(inputs)
	if (locale === "es-ES") return es_es2_builds_table_buildid1(inputs)
	if (locale === "es-MX") return es_mx2_builds_table_buildid1(inputs)
	if (locale === "fil") return fil_builds_table_buildid1(inputs)
	if (locale === "fr") return fr_builds_table_buildid1(inputs)
	if (locale === "it") return it_builds_table_buildid1(inputs)
	if (locale === "hu") return hu_builds_table_buildid1(inputs)
	if (locale === "nl") return nl_builds_table_buildid1(inputs)
	if (locale === "no") return no_builds_table_buildid1(inputs)
	if (locale === "pl") return pl_builds_table_buildid1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_table_buildid1(inputs)
	if (locale === "pt") return pt_builds_table_buildid1(inputs)
	if (locale === "ro") return ro_builds_table_buildid1(inputs)
	if (locale === "fi") return fi_builds_table_buildid1(inputs)
	if (locale === "sv") return sv_builds_table_buildid1(inputs)
	if (locale === "vi") return vi_builds_table_buildid1(inputs)
	if (locale === "tr") return tr_builds_table_buildid1(inputs)
	if (locale === "cs") return cs_builds_table_buildid1(inputs)
	if (locale === "bg") return bg_builds_table_buildid1(inputs)
	if (locale === "ru") return ru_builds_table_buildid1(inputs)
	if (locale === "uk") return uk_builds_table_buildid1(inputs)
	if (locale === "ar") return ar_builds_table_buildid1(inputs)
	if (locale === "hi") return hi_builds_table_buildid1(inputs)
	if (locale === "th") return th_builds_table_buildid1(inputs)
	if (locale === "ja") return ja_builds_table_buildid1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_table_buildid1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_table_buildid1(inputs)
	return ko_builds_table_buildid1(inputs)
});
export { builds_table_buildid1 as "builds.table.buildId" }